import { j as r } from "../../../node_modules/react/jsx-runtime.js";
import { memo as s } from "react";
import t from "./styles.module.scss.js";
const i = ({ direction: o = "horizontal" }) => /* @__PURE__ */ r.jsx("div", { className: t[o] }), p = s(i);
export {
  p as default
};
//# sourceMappingURL=Divider.js.map
